<div class="message-orchestrator-container">
  @for (message of messagesSignal(); track $index) {
  <dc-text-highlighter
    [message]="message"
    (playAudio)="playAudio.emit($event)"
    (audioCompleted)="onAudioCompleted($event)"
    (wordClicked)="onWordClicked($event)" />
  }
</div>
